<template>
    <div>
        <rkm-area title="Intervenções e/ou procedimentos clínicos realizados">
            <template slot="trailing">
                <rkm-button
                    @click="$refs.Modal.open()"
                    color="primary"
                    small
                    title="Adicionar"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>
            </template>

            <rkm-row>
                <rkm-col cols="12">
                    <List
                        :data="data"
                        @edit="$refs.Modal.open($event)"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox
                        class="mt-2"
                        v-model="data.model.orientacaoIndividualEmSaude"
                    >
                        Orientação individual em saúde
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'

export default {
    components: {List, Modal},
    props: {
        data: {type: Object, required: true},
    },
}
</script>
